import _ from "lodash";

import React from "react";
import PropTypes from "prop-types";
import {withApollo} from "react-apollo";

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import InputAdornment from "material-ui/Input/InputAdornment";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import LoginCard from "components/Cards/LoginCard.jsx";
import CustomInput from "components/CustomInput/CustomLoginInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import loginPageStyle from "../../../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
//import pagesStyle from "../../../assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";
import {validateUsers, createLoginLog} from "../graph";

import bgImage from "../../../assets/img/appen.jpg";

import SweetAlertModal from "../../etc/modals/SweetAlert";
import {client} from "client";
import Reaptcha from 'reaptcha';

const UAParser = require('ua-parser-js');

const DISABLETIMESEC = 120;

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '', 
      password: '',
      error: false,
      errorMessage :'',
      cardAnimaton: "cardHidden",
      showModal: false,
      disableLogin: false,
      captchaSuccess: false,
      errorContent: ''
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onVerify = this.onVerify.bind(this);
    this.loginFailedCount = 0;
    this.loginDisabledTime = DISABLETIMESEC;
    this.loginDisableInterval = null;
  }

  componentWillUnmount() {
    if (this.loginDisableInterval)
    clearInterval(this.loginDisableInterval);
  }

  handleSubmit(event){
    event.preventDefault();
    if (!this.state.username || !this.state.password) {
      this.setState({errorMessage: 'Please fill up both username and password'});
      return;
    }
    if (!this.state.captchaSuccess){
      this.setState({errorMessage: 'Please click the captcha box to proceed.'});
      return;
    }
    this.props.authProcess({
      variables:{
        username:this.state.username,
        password:this.state.password
      }
    }).then((result) => {
      if (_.isEmpty(result.errors)) {
        let parser = new UAParser();
        let p = parser.getResult();

        var data = JSON.parse(result.data.validateUsers.jsonObject);
        console.log("LOGIN FINISH");
        console.log(data);
        var AUTHTOKEN = data.authtoken.replace(/"/, '');

        this.loginFailedCount = 0;
        
        localStorage.setItem('APN_USERTYPE', data.usertype);
        localStorage.setItem('APN_AUTH_TKN', AUTHTOKEN);
        localStorage.setItem('APN_USERID', data.uid);
        localStorage.setItem('THUNDERPUSH_KEY', data.thunderpush_key);
        localStorage.setItem('THUNDERPUSH_HOST', data.thunderpush_host);
        client.mutate({
          mutation: createLoginLog,
          variables: ({
            browser: `${p.browser.name}-${p.browser.version}`, 
            os: `${p.os.name}-${p.os.version}`
          }),
            fetchPolicy: "no-cache"
        }).then((data) => {});


        //for some reason, i'm getting a server is down error if there is no timeout
        setTimeout(() => {
          this.props.history.push("/");
          window.location.reload();
        }, 100);
      }
      else{
        this.setState({error:true,errorMessage:result.errors[0].message,showModal:true});
      }

    }).catch((error) => {
      if ((error.toString()).includes("Failed to fetch")) {
        this.loginFailedCount = 0;
        this.setState({
          showModal: true,
          errorMessage:"Server down"
        });
      }
      else if((error.toString()).includes("Invalid credentials")){
        this.loginFailedCount++;
        this.captcha.reset();
        if (this.loginFailedCount >= 5) {
          this.onDisableLogin();
          localStorage.setItem('disableLogin', 1);
        }
        else {
          this.setState({
            error:true,
            errorMessage:"Oops! Something's wrong with your login details",
            showModal:true,
            captchaSuccess:false,
            errorContent: 'Please re-enter them or contact Appen for further assistance. (Remember usernames and passwords are case sensitive)'
          });
        }
      }
    });
  }

  onDisableLogin() {
    this.setState({
      error:true,
      errorMessage: `5 failed login attempts, you cannot login for ${this.loginDisabledTime} seconds.`,
      showModal:true,
      disableLogin: true
    });

    this.loginDisableInterval = setInterval( () => {
      this.loginDisabledTime--;

      localStorage.setItem('loginDisabledTime', this.loginDisabledTime);

      if (this.loginDisabledTime <= 0) {
        this.loginDisabledTime = DISABLETIMESEC;
        this.loginFailedCount = 0;
        clearInterval(this.loginDisableInterval);

        this.setState({
          showModal: false,
          disableLogin: false
        });

        localStorage.setItem('disableLogin', 0);
        localStorage.setItem('loginDisabledTime', this.loginDisabledTime);

        window.location.reload();
        return;
      }

      this.setState({
        error:true,
        errorMessage: `5 failed login attempts, you cannot login for ${this.loginDisabledTime} seconds.`,
        showModal:true,
        disableLogin: true
      });
    }, 1000);
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
        if (localStorage.getItem('disableLogin') == 1) {
          this.loginDisabledTime = localStorage.getItem('loginDisabledTime');
          this.onDisableLogin();
        }
      }.bind(this),
      700
    );
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }
  confirmBtnModal(){
    this.setState({
      showModal: false
    });
  }

  confirmBtnModalDisabled(){
    this.setState({
      showModal: true
    });
  }
  onVerify(){
    this.setState({
      'captchaSuccess':true
    })
  }

  render() {
    let { error, errorMsg, disableLogin } = this.state;
    let errorDiv = null;
    let confBtnModal = this.confirmBtnModal.bind(this);

    if (disableLogin)
      confBtnModal = this.confirmBtnModalDisabled.bind(this);

    let errorModal = (this.state.showModal) ? 
                    <SweetAlertModal 
                          show={true} 
                          message={this.state.errorMessage} 
                          confirmBtn={confBtnModal}
                          content={this.state.errorContent}
                    /> 
                  : null;

    if (error) {
      errorDiv = (
        <p>&bull; {error}</p>
      );
    }
    const { classes } = this.props;
    //console.log(classes);

    return(
      <div className={classes.wrapper} ref="wrapper">
        <div className={classes.fullPage}>
          <div className={classes.content}>
            <div className={classes.container}>
              <GridContainer justify="center">
                <ItemGrid xs={12} sm={6} md={4}>
                  <form>
                    <LoginCard
                      customCardClass={classes[this.state.cardAnimaton]}
                      headerColor="blue"
                      cardTitle="Appen Login"
                      footerAlign="center"
                      style={{overflow:"unset"}}
                      footer={
                        <Button type="submit" color="primary" onClick={this.handleSubmit} wd size="lg">
                          Login
                        </Button>
                      }
                      content={
                        <div>
                          <CustomInput
                            labelText="Username"
                            id="username"
                            error={this.state.error}
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{

                              endAdornment: (
                                <InputAdornment position="end" >
                                  <Face className={classes.inputAdornmentIcon}/>
                                </InputAdornment>
                              ),
                              name:'username',
                              value:this.state.username,
                              onChange:this.handleInputChange
                            }}
                          />
                          <CustomInput
                            labelText="Password"
                            id="password"
                            formControlProps={{
                              fullWidth: true
                            }}
                            error={this.state.error}
                            helpText={this.state.errorMessage}
                            inputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <LockOutline
                                    className={classes.inputAdornmentIcon}
                                  />
                                </InputAdornment>
                              ),
                              value:this.state.password,
                              type:'password',
                              name:'password',
                              onChange:this.handleInputChange
                            }}
                          />
                          <div>
                            <Reaptcha 
                              ref={e => (this.captcha = e)}
                              sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY} 
                              onVerify={this.onVerify} 
                              theme='dark'/>
                          </div>
                        </div>
                      }
                    >

                    </LoginCard>
                  </form>
                </ItemGrid>
              </GridContainer>
            </div>
          </div>
          <div
              className={classes.fullPageBackground}
              style={{ backgroundImage: "url(" + bgImage + ")" }}
            >
          </div>
        </div>
        { errorModal }
      </div>
    )
  }
}
Login.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)((validateUsers)(withApollo(Login)));


// WEBPACK FOOTER //
// ./src/views/auth/components/Login.js